module.exports = __webpack_public_path__ + "static/media/BeGamble.bde9544d.svg";